<template>
  <v-layout>
    <v-container>
      <v-flex xs12>
        <v-breadcrumbs
          large
          :items="items"
          divider=">"
        ></v-breadcrumbs>
      </v-flex>
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <v-card>
          <v-container
            fluid
            grid-list-sm
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                d-flex
                xs12
              >
                <v-form
                  ref="form"
                  v-model="valid"
                >
                  <h2 class="title mb-5">Next ID : {{currentCount}}</h2>
                  <v-text-field
                    v-model="number"
                    :rules="numRules"
                    type="number"
                    label="# of Label Needed"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="lotNumber"
                    readonly
                    label="Lot Number"
                  ></v-text-field>
                  <v-select
                    append-outer-icon="clear"
                    @click:append-outer="clearClient()"
                    v-model="client"
                    :items="clientList"
                    :rules="CleientRules"
                    :disabled="!createEntryCheckbox"
                    placeholder="Client"
                  ></v-select>

                  <v-select
                    v-model="client_lotNumber"
                    :items="clientLotList"
                    :disabled="!createEntryCheckbox"
                    label="Select Location"
                  ></v-select>
                  <v-btn
                    v-if="client && clientLotList.length === 0"
                    color='secondary'
                    @click="addLocationdialog = true"
                  >Create Location</v-btn>
                  <v-select
                    v-model="selectedPrinter"
                    :items="printerList"
                    label="Select Printer"
                    :rules="printerRules"
                    required
                  ></v-select>

                  <v-btn
                    :disabled="!valid"
                    color='primary'
                    @click="validate"
                  >Print</v-btn>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-container>
  </v-layout>
</template>


<script>
import webconfig from "../firebaseIDs"
import { mapFields } from "vuex-map-fields";
const fb = require("../firebaseConfig.js");
export default {
  components: {
  },
  data () {
    return {
      webconfig : webconfig,
      clientLotList: [],
      items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Labels',
          disabled: false,
          to: 'createLabel'
        },
      ],
      labelURL: null,
      lotNumber: null,
      clientList: [],
      clientDetail: [],
      client_lotNumber: null,
      preview: "",
      selectedPrinter: "",
      printerList: [],
      createEntryCheckbox: true,
      valid: true,
      number: 0,
      client: null,
      dymo: null,
      assetList: [],
      CleientRules: [],
      LocationRules: [],
      typeRules: [],
      printerRules: [v => !!v || "Printer is required"],
      numRules: [v => !!v || "Number is required"]
    };
  },
  beforeRouteEnter (to, from, next) {
    fb.SettingsCollections.doc("UniqueID")
      .get()
      .then(doc => {
        next(vm => (vm.currentCount = doc.data().currentCount, vm.lotNumber = doc.data().lotNumber));
      });
  },

  methods: {
    clearClient () {
      this.client = "";
      this.client_lotNumber = null
    },
    validate () {
      this.assetList = []
      if (this.$refs.form.validate()) {
        for (var i = 0; i < this.number; i++) {
          this.assetList.push(this.currentCount)
          this.dymoPrint(this.currentCount);
          if (this.client_lotNumber !== null) {
            fb.LocationsCollections.doc(this.client_lotNumber).update({
              assets: fb.firestore.FieldValue.arrayUnion(this.currentCount)
            })
          }

          this.currentCount++;
        }
        this.lotNumber++
        fb.LotsCollections.doc(this.lotNumber.toString()).set({
          lotNumber: this.lotNumber,
          client: this.client,
          createdDate: this.$moment().format("MM/DD/YYYY"),
          Assets: this.assetList
        }),

          fb.SettingsCollections.doc("UniqueID").update({
            currentCount: this.currentCount
          });
      } else {
        return false;
      }
    },
    dymoPrint (ID) {
      var label = this.dymo.openLabelFile(this.labelURL);
      label.setObjectText("BARCODE", ID);
      label.setObjectText("lotNum", this.lotNumber.toString());
      // var pngData = label.render();
      // this.preview = "data:image/png;base64," + pngData;
      label.print(this.selectedPrinter);
      //create placeholder entry

      if (this.createEntryCheckbox === true) {
        fb.AssetsCollections.doc(ID.toString()).set({
          AssetType: null,
          client: this.client,
          Discovery: {
            AssetTag: ID,
            Location: this.client_lotNumber,
            CpuTitle: null,
            HddTitle: null,
            RamTitle: null,
            OsTitle: "Windows 10",
            Status: "label_printed",
            SystemInfo: {
              Make: null,
              Model: null,
              Serial: null,
            },
            Mode: "offline",
            Time: this.$moment().format("MM/DD/YYYY hh:mm:ss a"),
          },
          sku: null,
          mischardwarespec: {
            conditionDesc: null,
            computerType: null,
            screensize: null,
            color: null,
            storageType: null,
            displayPort: false,
            ethernet: false,
            minidisplayport: false,
            hdmi: false,
            microHDMI: false,
            microUSB: false,
            miniEthernet: false,
            miniUSB: false,
            usb1: false,
            usb2: false,
            lanCard: false,
            camera3d: false,
            backLitKeyboard: false,
            bluetooth: false,
            microphone: false,
            webcam: false,
            hsdpa: false,
            rugged: false,
            tabletPC: false,
            touchScreen: false,
          },
          Time: this.$moment().format("MM/DD/YYYY hh:mm:ss a")
        });
      }
    }
  },
  mounted () {
    var gsReference = fb.storage.refFromURL(
      this.webconfig.webconfig.barcodeLable
    )
    gsReference.getDownloadURL().then(url => {
      this.labelURL = url
    })

      this.$loadScript(this.webconfig.webconfig.dymoJS).then(() => {
        this.dymo = dymo.label.framework;
        var printers = this.dymo.getPrinters();
        for (var i = 0; i < printers.length; i++) {
          var printer = printers[i];
          if (printer.printerType == "LabelWriterPrinter") {
            this.printerList.push(printer.name);
          }
        }
      })
    fb.CustomersCollections.onSnapshot(docs => {
      this.clientList = []
      this.clientDetail = []
      docs.forEach(doc => {
        this.clientList.push(doc.id);
        this.clientDetail.push({
          name: doc.id,
          locations: doc.data().locations
        })
      });
    }),
      {}
  },

  computed: {
    ...mapFields(["currentCount", "addLocationdialog"]),
  },
  watch: {
    createEntryCheckbox: function (val) {
      if (val === true) {
        this.LocationRules = [v => !!v || "Location is required"]
        this.CleientRules = [v => !!v || "Client is required"]
        this.typeRules = [v => !!v || "Asset type is required"]
      } else {
        this.LocationRules = []
        this.CleientRules = []
        this.typeRules = []
      }
    },
    client: function (val) {
      if (val !== "") {
        var item = this.clientDetail.filter(item => { return item.name === val })[0]
        this.clientLotList = item.locations
      }
      else {
        this.clientLotList = []
      }
    },
    clientDetail: function (val) {
      if (this.client !== null) {
        var item = val.filter(item => { return item.name === this.client })[0]
        this.clientLotList = item.locations
      }
    }

  }
};
</script>
